<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false" width="700px">
    <!-- 配置组合说明 -->
    <el-alert
      title="配置组合说明"
      type="info"
      :closable="false"
      style="margin-bottom: 20px">
      <div slot="default" class="config-tips">
        <p><strong>通用主通道:</strong> 显示=是, 作为备用=是 (推荐)</p>
        <p><strong>独立通道:</strong> 显示=是, 作为备用=否 (仅用户选择时使用)</p>
        <p><strong>纯备用通道:</strong> 显示=否, 作为备用=是 (前端不显示,仅智能切换)</p>
        <p><strong>临时禁用:</strong> 显示=否, 作为备用=否 (完全停用)</p>
      </div>
    </el-alert>

    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '140px' : '120px'">
          <el-form-item label="商户名称" prop="merchantsName">
          <el-input v-model="dataForm.merchantsName" placeholder="商户名称"></el-input>
      </el-form-item>
       <el-form-item label="商户类别" prop="merchantType">
          <el-input v-model="dataForm.merchantType" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="支付公司" prop="payName">
          <el-input v-model="dataForm.payName" placeholder="支付公司名称(例:支付宝,微信,汇付等)"></el-input>
      </el-form-item>
          <!-- <el-form-item label="支付类型(1:支付宝-官方  2:微信-官方  3:支付宝-三方  4:微信-三方)" prop="peyType">
          <el-input v-model="dataForm.peyType" placeholder="支付类型(1:支付宝-官方  2:微信-官方  3:支付宝-三方  4:微信-三方)"></el-input>
      </el-form-item> -->
      <el-form-item prop="peyType" label="支付类型" size="mini">
        <el-radio-group v-model="dataForm.peyType" :disabled="!!dataForm.id">
          <el-radio :label="3">支付宝</el-radio>
          <el-radio :label="2">微信</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="排序" prop="sort">
        <el-input-number v-model="dataForm.sort" :min="0" placeholder="排序数值" style="width: 100%;"></el-input-number>
        <div class="form-tip">
          <i class="el-icon-info"></i>
          排序值不能与其他通道重复；若与已有通道相同，后端会把两者的排序值互换
        </div>
      </el-form-item>

      <el-form-item label="支付金额范围">
        <el-col :span="11">
          <el-form-item prop="payMin">
            <el-input-number
              v-model="dataForm.payMin"
              :min="0"
              :precision="2"
              placeholder="最低金额"
              style="width: 100%;">
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="2" style="text-align: center;">~</el-col>
        <el-col :span="11">
          <el-form-item prop="payMax">
            <el-input-number
              v-model="dataForm.payMax"
              :min="0"
              :precision="2"
              placeholder="最高金额"
              style="width: 100%;">
            </el-input-number>
          </el-form-item>
        </el-col>
        <div class="form-tip">
          <i class="el-icon-info"></i>
          订单金额需满足「最低 ≤ 金额 ≤ 最高」，两端都含边界；超出范围的订单不会走该通道
        </div>
      </el-form-item>

      <!-- 是否作为备用配置 -->
      <el-form-item prop="isBackup" label="是否作为备用" size="mini">
        <el-radio-group v-model="dataForm.isBackup">
          <el-radio :label="1">可作为备用</el-radio>
          <el-radio :label="2">不参与切换</el-radio>
        </el-radio-group>
        <div class="form-tip">
          <i class="el-icon-info"></i>
          控制其他通道失败时,是否可以自动切换到该通道
        </div>
      </el-form-item>
          <el-form-item label="支付配置" prop="configurationJson">
          <el-input v-model="dataForm.configurationJson" placeholder="支付配置,如商户号,私钥,秘钥,公钥"></el-input>
      </el-form-item>
          <el-form-item label="备注" prop="remark">
          <el-input v-model="dataForm.remark" placeholder="备注(支付通道的对接注意事项以及使用说明)"></el-input>
      </el-form-item>

          <el-form-item label="显示名称" prop="showName">
          <el-input v-model="dataForm.showName" placeholder="页面显示名称(如支付宝H5,微信H5等)"></el-input>
      </el-form-item>
          <el-form-item label="调用名称" prop="callName">
          <el-input v-model="dataForm.callName" placeholder="调用名称(通道调用名称)"></el-input>
      </el-form-item>
        <el-form-item label="通道编码" prop="bankCode">
          <el-input v-model="dataForm.bankCode" placeholder="通道编码"></el-input>
      </el-form-item>
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        merchantsName: '',
        merchantType: '',
        payName: '',
        peyType: '',
        bankCode: '',
        qrCode:'',
        qrCodeName: '',
        status: 1,          // 默认显示
        isBackup: 1,        // 默认可作为备用
        configurationJson: '',
        remark: '',
        showName: '',
        callName: '',
        sort: 0,
        payMin: 10,
        payMax: 500,
        time: ''
      }
    }
  },
  computed: {
    // 判断是否为RG微信或RG支付宝
    isRGPayment() {
      return this.dataForm.merchantsName === 'RG微信' || this.dataForm.merchantsName === 'RG支付宝'
    },
    dataRule () {
      const baseRules = {
        merchantsName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        merchantType: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        payName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        peyType: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        isBackup: [
          { required: true, message: '请选择是否作为备用', trigger: 'change' }
        ],
        configurationJson: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        remark: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        showName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        callName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        sort: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        bankCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }

      // 如果是RG微信或RG支付宝，添加二维码字段的验证规则
      // if (this.isRGPayment) {
      //   baseRules.qrCode = [
      //     { required: true, message: '请上传二维码图片', trigger: 'blur' }
      //   ]
      //   baseRules.qrCodeName = [
      //     { required: true, message: '请输入二维码姓名', trigger: 'blur' }
      //   ]
      // }

      return baseRules
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/payConfig/payconfig/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/payConfig/payconfig/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>

<style scoped>
.form-tip {
  color: #909399;
  font-size: 12px;
  line-height: 1.5;
  margin-top: 4px;
}
.form-tip i {
  margin-right: 4px;
}
.config-tips p {
  margin: 8px 0;
  line-height: 1.6;
}
.config-tips strong {
  color: #303133;
}
</style>
